import { motion } from "framer-motion";

const StartupGallery = () => {
  const galleryItems = [
    { image: "/main21.jpg", title: "" }, // HERO
    { image: "/main3.jpeg", title: "Warehousing Facility" },
    { image: "/main10.png", title: "Logistics Operations" },
    { image: "/main11.png", title: "Product Distribution" },
    { image: "/award1.png", title: "International Trade" },
    { image: "/award2.png", title: "Retail Supply Chain" },
    { image: "/award3.png", title: "Export Packaging" },
  ];

  return (
    <section className="bg-[#d9f0ea] py-20">
      <div className="max-w-7xl mx-auto px-4">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-14"
        >
          <p className="uppercase tracking-widest text-sm text-gray-600">
            Gallery
          </p>
          <h1 className="text-4xl font-bold text-gray-800 mt-2">
            Our Startup Journey
          </h1>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            A glimpse into our operational strength, supply chain processes,
            and international trading activities.
          </p>
        </motion.div>

        {/* HERO IMAGE (Full Width) */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <div className="relative rounded-2xl overflow-hidden shadow-lg">
            <img
              src={galleryItems[0].image}
              alt={galleryItems[0].title}
              className="w-full h-[300px] md:h-[450px] object-cover"
            />
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
              <h2 className="text-white text-2xl md:text-3xl font-bold">
                {galleryItems[0].title}
              </h2>
            </div>
          </div>
        </motion.div>

        {/* GRID FOR REMAINING 6 IMAGES */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={{
            visible: { transition: { staggerChildren: 0.15 } },
          }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {galleryItems.slice(1).map((item, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 40 },
                visible: { opacity: 1, y: 0 },
              }}
              whileHover={{ scale: 1.04 }}
              className="relative rounded-2xl overflow-hidden shadow-md"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-60 object-cover"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black/40 opacity-0 hover:opacity-100 transition flex items-center justify-center">
                <h3 className="text-white text-lg font-semibold text-center px-4">
                  {item.title}
                </h3>
              </div>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default StartupGallery;